  <div class='container'>
    <data-table
    title='Permisos'
    [columns]='columnasPermisos'
    [configuration]='configurationPermisos'
    [reloadTable]='recargarTablaPermisos'
    (add)='agregarPermisos($event)'
    (edit)='editarPermisos($event)'
    (delete)='eliminarPermisos($event)'
    (selection)='seleccionadosPermisos($event)'
    (view)='viewPermissions($event)'
    [params]='[]'
    [url]='urlGetPermisos'
    ></data-table>
  </div>
